import { Pipe, PipeTransform } from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
  standalone: true,
  name: 'addExpireDate'
})
export class AddExpirationDatePipe implements PipeTransform {
  transform(downloadTTL: number, pattern: string = ""): string {
    const currentTime = Date.now();
    const combinedTime = new Date( currentTime + downloadTTL * 1000);
    return Utils.formatDate(combinedTime, pattern);
  }
}
